import Locales from './Locales'

export default Locales
